import React from "react"
import Box from "@mui/material/Box"
import { SxProps, Theme } from "@mui/material"
import { ReactNode } from "react"
import { useConfig } from "../../hooks/useConfig"
import { aspectRatioToNumeric } from "../../utils/AspectRatioUtil"

interface MediaContainerProps {
  sx?: SxProps<Theme>
  children: ReactNode
}

export default function MediaContainer({ sx, children }: MediaContainerProps) {
  const config = useConfig()

  return (
    <Box
      sx={{
        position: "relative",
        justifySelf: "center",
        width: 1,
        maxWidth: 720,
        aspectRatio: aspectRatioToNumeric(config.aspectRatio),
        borderRadius: 2,
        overflow: "hidden",
        mx: "auto",
        bgcolor: "rgba(0,0,0,0.25)",
        boxShadow: "0px 8px 10px rgba(0,0,0,0.25)",
        ...(sx as object),
      }}
    >
      {children}
    </Box>
  )
}
